import { Component, ViewEncapsulation } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { AppService } from './app.service';
import { filter, pairwise } from 'rxjs/operators';
import { ObjectTypes } from "@common/enums/object-types";
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { RecordFactory } from "@common/data-models/records/record-factory";
import { CollectionRecord } from "@common/data-models/records/collection-record";
import { ExportFormatRecord } from "@common/data-models/records/export-format-record";
import { UserRecord } from "@common/data-models/records/user-record";
import { ContactRecord } from "@common/data-models/records/contact-record";
import { ViewStateRecord } from "@common/data-models/records/viewstate-record";
import { SingleViewStateRecord } from "@common/data-models/records/single-viewstate-record";
import { TopicViewStateRecord } from "@common/data-models/records/topic-viewstate-record";
import { WireViewStateRecord } from "@common/data-models/records/wire-viewstate-record";
import { DraftViewStateRecord } from "@common/data-models/records/draft-viewstate-record";
import { SingleTopicViewStateRecord } from "@common/data-models/records/single-topic-viewstate-record";
import { AssignmentViewStateRecord } from "@common/data-models/records/assignment-viewstate-record";
import { SearchViewStateRecord } from "@common/data-models/records/search-viewstate-record";
import { WireSearchViewStateRecord } from "@common/data-models/records/wire-search-viewstate-record";
import { SlideshowViewStateRecord } from "@common/data-models/records/slideshow-viewstate-record";
import { AssignmentRecord } from "@playbook/data-models/records/assignment-record";
import { TopicRecord } from "@playbook/data-models/records/topic-record";
import { TopicTemplateRecord } from "@playbook/data-models/records/topic-template-record";
import { WireRecord } from "@discover/data-models/records/wire-record";
import { DraftRecord } from "@journal/data-models/records/draft-record";
import { DiscoverService } from '@discover/services/discover-service'
import { DiscoverSearchService } from '@discover/services/discover-search-service';
import { LiveService } from '@live/services/live-service';
import { CastService } from '@cast/services/cast-service';
import { JournalService } from '@journal/services/journal-service';

import { PlaybookService } from "@playbook/services/playbook-service";
import { RundownListViewStateRecord } from './common/data-models/records/rundown-list-viewstate-record';
import { RundownRecord } from './live/data-models/records/rundown-record';
import { PublicationRecord } from './cast/data-models/records/publication-record';
import { PublicationListRecord } from './cast/data-models/records/publication-list-record';
import { StoryRecord } from '@live/data-models/records/story-record';
import { PublicationChannelRecord } from './common/data-models/records/publication-channel-record';
import { ScheduleViewStateRecord } from './common/data-models/records/schedule-viewstate-record';
import { Record } from '@common/data-models/records/record';
import { DraftSearchViewStateRecord } from "@common/data-models/records/draft-search-viewstate-record";
import { PublicationViewStateRecord } from '@common/data-models/records/publication-viewstate-record';
import { RSSFeedViewStateRecord } from '@common/data-models/records/rss-feed-viewstate-record';
import { TwitterFeedViewStateRecord } from '@common/data-models/records/twitter-feed-viewstate-record';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    host: {
        'class': 'st-app-component'
    },
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {

    private registerRecords() {
        RecordFactory.registerRecord(ObjectTypes.NGGRID, CollectionRecord);
        RecordFactory.registerRecord(ObjectTypes.STORYBOARD, CollectionRecord);
        RecordFactory.registerRecord(ObjectTypes.EXPORTFORMAT, ExportFormatRecord);
        RecordFactory.registerRecord(ObjectTypes.USER, UserRecord);
        RecordFactory.registerRecord(ObjectTypes.PSTVIEWSTATE, ViewStateRecord);
        RecordFactory.registerRecord(ObjectTypes.ASSIGNMENT, AssignmentRecord);
        RecordFactory.registerRecord(ObjectTypes.TOPIC, TopicRecord);
        RecordFactory.registerRecord(ObjectTypes.WIRE, WireRecord);
        RecordFactory.registerRecord(ObjectTypes.DRAFT, DraftRecord);
        RecordFactory.registerRecord(ObjectTypes.RUNDOWN, RundownRecord);
        RecordFactory.registerRecord(ObjectTypes.SCRIPT, StoryRecord);
        RecordFactory.registerRecord(ObjectTypes.CONTACT, ContactRecord);
        RecordFactory.registerRecord(ObjectTypes.PUBLICATION_CHANNEL, PublicationChannelRecord);
        RecordFactory.registerRecord(ObjectTypes.PUBLICATION, PublicationRecord);
        RecordFactory.registerRecord(ObjectTypes.UNASSIGNED, Record);
        RecordFactory.registerRecord(ObjectTypes.PUBLICATIONLIST, PublicationListRecord);
        RecordFactory.registerTemplateRecord(ObjectTypes.TOPIC, TopicTemplateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SYSTEM, ViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.TOPIC, TopicViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.ASSIGNMENT, AssignmentViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SEARCH, SearchViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SLIDESHOW, SlideshowViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.SINGLETOPIC, SingleTopicViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.DRAFT, DraftViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.DRAFTSEARCH, DraftSearchViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.WIRE, WireViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.WIRESEARCH, WireSearchViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.ROLIST, RundownListViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.PUBLICATION, PublicationViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.RSSFEED, RSSFeedViewStateRecord);
        RecordFactory.registerViewStateRecord(ViewStateTypes.TWITTERFEED, TwitterFeedViewStateRecord);
    }

    constructor(
        private router: Router,
        private appService: AppService,
        public playbookService: PlaybookService,
        public journalService: JournalService,
        public liveService: LiveService,
        public castService: CastService,
        public discoverService: DiscoverService,
        public discoverSearchService: DiscoverSearchService
    ) {
        this.registerRecords();

        this.router.events.pipe(filter((e: any) => e instanceof RoutesRecognized), pairwise())
            .subscribe((e: any) => {
                localStorage.setItem('prevUrl', e[1].urlAfterRedirects);
                this.appService.previousUrl = e[1].urlAfterRedirects;
            });
    }
}
